import { PasswordInput, Text, Group, Anchor } from "@mantine/core";
import { FC } from "react";

type Props = {
  className: string;
  style?: {};
  others?: any;
  name?: string;
  forgotPassword: CallableFunction;
  onChange?: (...args: any) => any;
  isErrored?: string;
};
const ForgotPasswordInput: FC<Props> = ({
  className,
  onChange,
  forgotPassword,
  isErrored: _isErrored,
  ...others
}) => {
  return (
    <div className={className} style={{ paddingTop: "8px", width: "100%", height: "100%" }}>
      <Group justify="space-between" mb={8}>
        <Text component="label" htmlFor="your-password" size="sm" c="#3C4257">
          Password
        </Text>
        <Anchor<"a">
          href="#"
          data-testid="forgot-password-link"
          onClick={(event) => {
            event.preventDefault();
            forgotPassword();
          }}
          sx={(theme) => ({
            paddingTop: 2,
            color: "#338F86",
            fontWeight: 500,
            fontSize: theme.fontSizes.sm,
          })}
        >
          Forgot your password?
        </Anchor>
      </Group>
      <div>
        <PasswordInput
          onChangeCapture={(value) => (onChange ? onChange(value) : "")}
          defaultVisible={false}
          placeholder="Enter Your Password"
          id="your-password"
          size="md"
          {...others}
        />
      </div>
    </div>
  );
};

export default ForgotPasswordInput;
